import AxiosClient from '../../../services/axios.services';

class SurveyTemplateServices {
  getSurveyTemplates = (params) =>
    AxiosClient.get("/api/app/Survey/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getSurveyTemplate = (id) =>
    AxiosClient.get(`/api/app/Survey/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveSurveyTemplate = (data) =>
    AxiosClient.post("/api/app/Survey/", data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  editSurveyTemplate = (id, data) =>
    AxiosClient.put(`/api/app/Survey/${id}/`, data, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  deleteSurveyTemplate = (id) =>
    AxiosClient.delete(`/api/app/Survey/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new SurveyTemplateServices();